import axios from 'axios';
import { SignupAttribution } from './measurement';
import { getStoredAuthState, handleExpiredSession } from './auth';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

let interceptorInitialized = false;

export const setupAuthInterceptor = () => {
  if (interceptorInitialized) return;
  interceptorInitialized = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const hasToken = Boolean(getStoredAuthState().token);
      // 401 = token expired/invalid → log out.
      // 403 = authenticated but not authorized for this resource (e.g. admin viewing
      //       another user's data) — do NOT log out, let the caller handle it.
      if (status === 401 && hasToken) {
        handleExpiredSession();
      }
      return Promise.reject(error);
    }
  );
};

export const login = async (email: string, password: string) => {
  const res = await axios.post(`${API_BASE}/auth/login`, { email, password });
  return res.data;
};

export const register = async (
  email: string,
  password: string,
  firstName: string,
  lastName: string,
  phoneNumber?: string,
  ico?: string,
  plannedApartmentCount?: number,
  preferredBillingCycle?: string,
  attribution?: SignupAttribution
) => {
  const res = await axios.post(`${API_BASE}/auth/register`, {
    email,
    password,
    firstName,
    lastName,
    phoneNumber,
    ico,
    plannedApartmentCount,
    preferredBillingCycle,
    attribution,
  });
  return res.data;
};

export const resendConfirmation = async (email: string) => {
  const res = await axios.post(`${API_BASE}/auth/resend-confirmation`, { email });
  return res.data;
};

// Add more API calls as needed
